import AuthService from '@/services/api/authentication/authentication-service.js';

const state = {
  authentications: [],
  hasAuth: undefined,
};

const getters = {
  authentications: state => state.authentications,
  hasAuth: state => state.authentications.length > 0,
};

const mutations = {
  setAuthentications: (state, data) => {
    state.authentications = data;
  },
};

const actions = {
  getAuthentications({ getters, commit }) {
    const found = getters.authentications;
    if (found.length > 0) {
      return new Promise(resolve => {
        resolve(found);
      });
    } else {
      return AuthService.getAuthentications().then(auths => {
        commit('setAuthentications', auths);
        return auths;
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
